import React from 'react';
import './styles.scss'

export const SectionInstruction = ({instructionText}) => {
  return (
    <label className='section-instruction subtitle1'>
      {instructionText}
    </label>
  )
}

export default SectionInstruction;